(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pawpix-delais"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('pawpix-delais')) return;

    const TZ = 'Europe/Paris';
    const pad = (n) => String(n).padStart(2, '0');
    const key = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

    // Jours fériés français (fixes + Pâques, Ascension, Pentecôte)
    const holidaysCache = {};
    function holidays(y) {
      if (holidaysCache[y]) return holidaysCache[y];
      const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
      const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
      const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
      const easter = new Date(y, month - 1, day);
      const plus = (n) => key(new Date(y, easter.getMonth(), easter.getDate() + n));
      const set = new Set(['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'].map((md) => `${y}-${md}`));
      [1, 39, 50].forEach((n) => set.add(plus(n)));
      return (holidaysCache[y] = set);
    }

    // Fermetures atelier : "2026-12-24/2027-01-02, 2027-08-01/2027-08-15"
    function parseClosures(str) {
      return (str || '').split(',').map((r) => r.trim()).filter(Boolean).map((r) => {
        const [from, to] = r.split('/').map((s) => s.trim());
        return [from, to || from];
      });
    }

    function isOff(d, closures) {
      const day = d.getDay();
      if (day === 0 || day === 6) return true;
      const k = key(d);
      if (holidays(d.getFullYear()).has(k)) return true;
      return closures.some(([from, to]) => k >= from && k <= to);
    }

    function addWorkingDays(start, n, closures) {
      const d = new Date(start);
      let added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        if (!isOff(d, closures)) added++;
      }
      return d;
    }

    // Date/heure actuelles à Paris, quel que soit le fuseau du visiteur
    function parisNow() {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
          .formatToParts(new Date()).map((p) => [p.type, p.value])
      );
      return { date: new Date(+parts.year, +parts.month - 1, +parts.day), hour: +parts.hour };
    }

    const fmtDay = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    const fmtD = new Intl.DateTimeFormat('fr-FR', { day: 'numeric' });
    const fmtDM = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });

    function range(a, b) {
      if (key(a) === key(b)) return fmtDay.format(a);
      if (a.getMonth() === b.getMonth()) return `${fmtD.format(a)} – ${fmtDM.format(b)}`;
      return `${fmtDM.format(a)} – ${fmtDM.format(b)}`;
    }

    class PawpixDelais extends HTMLElement {
      connectedCallback() {
        const fab = +this.dataset.fab || 5;
        const min = +this.dataset.min || 4;
        const max = Math.max(+this.dataset.max || 8, min);
        const cutoff = this.dataset.cutoff === '' ? 24 : +this.dataset.cutoff;
        const closures = parseClosures(this.dataset.closed);

        const now = parisNow();
        // Après l'heure limite, la commande est traitée comme passée le lendemain
        const start = new Date(now.date);
        if (now.hour >= cutoff) start.setDate(start.getDate() + 1);

        const ship = addWorkingDays(start, fab, closures);
        const from = addWorkingDays(ship, min, closures);
        const to = addWorkingDays(ship, max, closures);

        const set = (name, txt) => { const el = this.querySelector(`[data-ppx="${name}"]`); if (el) el.textContent = txt; };
        set('ship', fmtDay.format(ship));
        set('deliver', range(from, to));
      }
    }
    customElements.define('pawpix-delais', PawpixDelais);
  })();
  } catch(e) { console.error(e); }
})();

})();
